// extracted by mini-css-extract-plugin
module.exports = {"grid":"Styles_grid__ERKfG","item":"Styles_item__iRhtV","container":"Styles_container__bItGX","title":"Styles_title__GKqY7","description":"Styles_description__oLchH"};